module.exports = __webpack_public_path__ + "VIPV11.png?939bad171f6f13a9b239b7eade105bcf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/colours/horses/VIPV11.png
// module id = 105
// module chunks = 0